import React from 'react';
import { DropResult } from 'react-beautiful-dnd';

import {
  MenuManagementDeliveryStore,
  UpdateMenuSet,
} from '@/pages/menu-managements/allocated-menus/service';
import { SearchBrandMenuResponse } from '@/services/BrandMenu/hooks/search/useMenuManagementBrandMenuSearch';
import { SearchBrandMenuHourResponse } from '@/services/BrandMenuHour/hooks/search/useMenuManagementBrandMenuHourSearch';

import { MenuManagementAllocatedMenusModalInner } from './MenuManagementAllocatedMenusModalInner';

type Props = {
  brandMenuOptions: SearchBrandMenuResponse[];
  menuSets: UpdateMenuSet[];
  isOpen: boolean;
  targetDeliveryStore: MenuManagementDeliveryStore;
  brandMenuHourOptions: SearchBrandMenuHourResponse[];
  handleCloseModal: () => void;
  handleChangeBrandMenu: (index: number, brandMenuId: string) => void;
  handleChangeBrandMenuHour: (index: number, brandMenuHourId: string) => void;
  handleAddMenuSet: () => void;
  handleRemoveMenuSet: (brandMenuIndex: number) => void;
  handleUpdate: () => void;
  handleOnDragEnd: (result: DropResult) => void;
};

export const MenuManagementAllocatedMenusRegisterModal: React.FC<Props> = ({
  brandMenuOptions,
  menuSets,
  isOpen,
  targetDeliveryStore,
  brandMenuHourOptions,
  handleCloseModal,
  handleChangeBrandMenu,
  handleChangeBrandMenuHour,
  handleAddMenuSet,
  handleRemoveMenuSet,
  handleUpdate,
  handleOnDragEnd,
}) => {
  return (
    <>
      {isOpen && (
        <MenuManagementAllocatedMenusModalInner
          target="更新"
          handleSubmit={handleUpdate}
          {...{
            isOpen,
            brandMenuOptions,
            handleCloseModal,
            menuSets,
            targetDeliveryStore,
            brandMenuHourOptions,
            handleChangeBrandMenu,
            handleChangeBrandMenuHour,
            handleAddMenuSet,
            handleRemoveMenuSet,
            handleOnDragEnd,
          }}
        />
      )}
    </>
  );
};
